import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ScheduleServiceInterface } from './schedule.interface';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService implements ScheduleServiceInterface {

  constructor(private httpClient: HttpClient) {
  }

  GetProposedFieldVisitSchedule(courseApprovalId: string): Observable<any> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `Schedule/GetProposedFieldVisitSchedule/${courseApprovalId}`);
  }

  SaveProposedFieldVisitSchedule(fieldVisitScheduleProprosal: any): Observable<any> {
    return this.httpClient.post<any>(environment.apiBaseUrl + `Schedule/SaveProposedFieldVisitSchedule`, fieldVisitScheduleProprosal);
  }

  ConfirmTSAProposedFieldVisitSchedule(courseApprovalId: any): Observable<any> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `Schedule/ConfirmTSAProposedFieldVisitSchedule/${courseApprovalId}`);
  }
}
